import "./AddSport.css";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import AddSportViewModel from "./AddSportViewModel";
import ButtonSpinner from "../../../../Components/Spinners/ButtonSpinner";
import IsSchoolAdded from "../../../../Hooks/IsSchoolAdded";

const AddSport = () => {
  const {
    RegisterSport,
    AddSport,
    setAddSport,
    SportIDError,
    SportNameError,
    CoachNameError,
    StartedYearError,
    FormDisabled,
    IsUpdate,
  } = AddSportViewModel();

  const SchoolAddedResp = IsSchoolAdded();
  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper add-sport-page">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">
                  {IsUpdate === true ? "Update Sport" : "Add Sport"}
                </h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={`/user/admin/sports`}>Sports</Link>
                  </li>
                  <li className="breadcrumb-item active">
                    {IsUpdate === true ? "Update Sport" : "Add Sport"}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="row">
                      <div className="col-12">
                        <h5 className="form-title">
                          <span>Sport Information</span>
                        </h5>
                        {!SchoolAddedResp && (
                          <div className="add-school-first-container">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              className="bi bi-exclamation-triangle-fill"
                              viewBox="0 0 16 16"
                            >
                              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                            </svg>
                            <p>Please add school first!</p>
                          </div>
                        )}
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Sport ID <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              SportIDError === true && "error-message"
                            }`}
                            type="text"
                            onChange={(e) => {
                              setAddSport({
                                ...AddSport,
                                SportID: e.target.value,
                              });
                            }}
                            value={AddSport.SportID}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                          {SportIDError === true ? (
                            <span className="admin-add-sport-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Sport Id is required.
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-sport-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Sport Id is required.
                              </span>
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Sport Name <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              SportNameError === true && "error-message"
                            }`}
                            type="text"
                            onChange={(e) => {
                              setAddSport({
                                ...AddSport,
                                SportName: e.target.value,
                              });
                            }}
                            value={AddSport.SportName}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                          {SportNameError === true ? (
                            <span className="admin-add-sport-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Sport name is required and cannot be less than 3
                                characters
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-sport-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Sport name is required and cannot be less than 3
                                characters
                              </span>
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Coach Name <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              CoachNameError === true && "error-message"
                            }`}
                            type="text"
                            onChange={(e) => {
                              setAddSport({
                                ...AddSport,
                                CoachName: e.target.value,
                              });
                            }}
                            value={AddSport.CoachName}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                          {CoachNameError === true ? (
                            <span className="admin-add-sport-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Coach name is required and cannot be less than 3
                                characters
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-sport-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Coach name is required and cannot be less than 3
                                characters
                              </span>
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Started Year <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              StartedYearError === true && "error-message"
                            }`}
                            type="text"
                            onChange={(e) => {
                              setAddSport({
                                ...AddSport,
                                StartedYear: e.target.value,
                              });
                            }}
                            value={AddSport.StartedYear}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                          {StartedYearError === true ? (
                            <span className="admin-add-sport-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Sport started year is required and cannot be
                                less than 4 characters
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-sport-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Sport started year is required and cannot be
                                less than 4 characters
                              </span>
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="student-submit">
                          <button
                            type="submit"
                            className="btn btn-primary"
                            onClick={(e) => {
                              e.preventDefault();
                              RegisterSport();
                            }}
                            disabled={FormDisabled || !SchoolAddedResp}
                          >
                            {FormDisabled && <ButtonSpinner />}{" "}
                            {IsUpdate === true ? "Update " : "Submit"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </Fragment>
  );
};

export default AddSport;
